import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const RESETCARTFUNNELBLOCK_LEGACY_FIELD_ORDER = [];

const {
  resetCartFunnelBlockDescriptor: _generatedResetCartFunnelBlockDescriptor,
  resetCartFunnelBlockBlocDefinition,
  resetCartFunnelBlockDashboardLayout,
  resetCartFunnelBlockConfig,
  resetCartFunnelBlockResolveConfig,
  resetCartFunnelBlockProperties,
} = doodBlockConfig(
  {
    name: "Reset cart funnel",
    componentType: 'ResetCartFunnelBlockComponent',
    category: 'system',
    description: "Reset cart funnel.",
    keywords: [],
    allowedIn: [{ bloc: 'OrderStatusPageComponent', slot: 'body' }],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function resetCartFunnelBlockDescriptor(): IBlockDescriptor;
export function resetCartFunnelBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function resetCartFunnelBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedResetCartFunnelBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedResetCartFunnelBlockDescriptor, resetCartFunnelBlockProperties, fieldOrder);
}

export {
  resetCartFunnelBlockBlocDefinition,
  resetCartFunnelBlockDashboardLayout,
  resetCartFunnelBlockProperties,
  resetCartFunnelBlockConfig,
  resetCartFunnelBlockResolveConfig,
};

export type ResetCartFunnelBlockConfig = typeof resetCartFunnelBlockConfig;
